module.exports = __webpack_public_path__ + "img/xinwen10.be158b3f.jpg";